import React from 'react';
import { useTranslation } from 'react-i18next';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Label } from 'recharts';

const LineChartWidget = ({ data, config }) => {
    const { t } = useTranslation();
    const xAxisKey = config?.config?.xAxisKey || config?.xAxisKey || 'name';
    const yAxisKey = config?.config?.yAxisKey || config?.yAxisKey || 'value';
    const xAxisFormatter = config?.config?.xAxisFormatter || config?.xAxisFormatter;
    const yAxisFormatter = config?.config?.yAxisFormatter || config?.yAxisFormatter;
    const yAxisDomain = config?.config?.yAxisDomain || config?.yAxisDomain;
    const tooltipFormatter = config?.config?.tooltipFormatter || config?.tooltipFormatter;
    const targetValue = config?.config?.targetValue ?? config?.targetValue;
    const targetLabelKey = config?.config?.targetLabelKey || config?.targetLabelKey;

    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <p style={{ color: '#605E5C' }}>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
                <defs>
                    <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%"  stopColor="#00A4A6" stopOpacity={0.25} />
                        <stop offset="95%" stopColor="#00A4A6" stopOpacity={0.02} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#e1e1e1" vertical={false} />
                <XAxis
                    dataKey={xAxisKey}
                    tickFormatter={xAxisFormatter}
                    tick={{ fontSize: 12, fill: '#605E5C' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    tick={{ fontSize: 12, fill: '#605E5C' }}
                    tickFormatter={yAxisFormatter}
                    domain={yAxisDomain}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    labelFormatter={xAxisFormatter}
                    formatter={tooltipFormatter}
                    contentStyle={{ fontSize: 13, borderColor: '#e1e1e1', borderRadius: 6 }}
                />
                {targetValue !== undefined && targetValue !== null && (
                    <ReferenceLine
                        y={targetValue}
                        stroke="#1B3A6B"
                        strokeDasharray="5 5"
                        strokeWidth={2}
                        ifOverflow="extendDomain"
                    >
                        <Label
                            value={targetLabelKey ? `${t(targetLabelKey)}: ${targetValue}` : `${t('TARGET')}: ${targetValue}`}
                            position="insideTopRight"
                            fill="#1B3A6B"
                            fontSize={11}
                            fontWeight={600}
                        />
                    </ReferenceLine>
                )}
                <Area
                    type="monotone"
                    dataKey={yAxisKey}
                    stroke="#00A4A6"
                    strokeWidth={2}
                    fill="url(#areaGradient)"
                    dot={{ r: 3, fill: '#00A4A6', strokeWidth: 0 }}
                    activeDot={{ r: 5, fill: '#00A4A6' }}
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default LineChartWidget;
